import React, { useEffect } from "react";
import useForceUpdate from "use-force-update";
import { makeStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Slider from "./slider";
import DateTime from "./datetimepicker";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));
const ControlledExpansionPanels = (props) => {
  //console.log(props.panel);
  var dataval = props.showdata;
  const [datanew, datanewedit] = React.useState({
    name: dataval,
    id: 123,
  });
  function begin() {
    //console.log(JSON.stringify(props.showdata));
    datanewedit({
      ...datanew,
      name: props.showdata,
    });
  }
  useEffect(() => {
    if (datanew.name == props.showdata) return;

    datanewedit({
      datanew,
      name: props.showdata,
    });
  });
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const DynamicTabs = props.panel[0].checklist.InnerDetails.map((index) => {
    let id = index.Title;
    return (
      <React.Fragment>
        <ExpansionPanel
          expanded={expanded === id}
          onChange={handleChange(id)}
          className="customexpansion"
        >
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon className="expandcolor" />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className="customcoll"
          >
            <Typography className={classes.heading}>{index.Title}</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className="">
            <div className="">
              {index.InputType == "Checkbox" && (
                <div className=" col s12">
                  <label>
                    <input type="checkbox" class="filled-in" />
                    <span className="checkbox-custom">Buisness Name</span>
                  </label>
                </div>
              )}

              {index.InputType == "Text field" && (
                <div className="input-field col s12">
                  <input id="country" type="text" class="validate" />
                  <label for="country">Buisness Name</label>
                </div>
              )}
              {index.InputType == "Anotation" && (
                <div className="input-field col s12 center-align">
                  <span className="checkbox-custom">Buisness Name</span>
                  <button class="btn waves-effect waves-light">
                    Anotation
                  </button>
                </div>
              )}

              {index.InputType == "Slider" && (
                <div className="input-field col s12 center-align">
                  <div className="container">
                    <Slider />
                  </div>
                </div>
              )}

              {index.InputType == "DateTime" && (
                <div className="input-field col s12 center-align">
                  <DateTime />
                </div>
              )}

              {datanew.name == "Text Field" && (
                <div className="input-field col s12">
                  <input id="country" type="text" class="validate" />
                  <label for="country">Buisness Name</label>
                </div>
              )}
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </React.Fragment>
    );
  });

  //alert(JSON.stringify(props.panel[0].checklist.InnerDetails))
  return <div className={classes.root}>{DynamicTabs}</div>;
};
export default ControlledExpansionPanels;
